// src/pages/SuccessPage.js
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./SuccessPage.css";

export default function SuccessPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const table = params.get("table") || "";

  useEffect(() => {
    const t = setTimeout(() => {
      navigate(`/menu?table=${table}`);
    }, 3000);

    return () => clearTimeout(t);
  }, [table, navigate]);

  return (
    <div className="success-page container text-center py-5">
      <div className="card p-4 mx-auto" style={{ maxWidth: 520 }}>
        <h1>سفارش ثبت شد</h1>
        <p>سفارش شما با موفقیت ارسال شد.</p>
        <p>میز: {table}</p>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(`/menu?table=${table}`)}
        >
          بازگشت به منو
        </button>
      </div>
    </div>
  );
}
